import Vue from 'vue'

let fontFamily_ZH = [
  {
    "value": "SimSun",
    "label": "宋体"
  }, {
    "value": "SimHei",
    "label": "黑体"
  }, {
    "value": "Microsoft-YaHei",
    "label": "微软雅黑"
  }, {
    "value": "KaiTi",
    "label": "楷体"
  }, {
    "value": "FangSong",
    "label": "仿宋"
  }, {
    "value": "Times-New-Roman",
    "label": "Times-New-Roman"
  }, {
    "value": "sans-serif",
    "label": "sans-serif"
  }
];

let fontFamily_EN = [
  {
    "value": "SimSun",
    "label": "SimSun"
  }, {
    "value": "SimHei",
    "label": "SimHei"
  }, {
    "value": "Microsoft-YaHei",
    "label": "Microsoft-YaHei"
  }, {
    "value": "KaiTi",
    "label": "KaiTi"
  }, {
    "value": "FangSong",
    "label": "FangSong"
  }, {
    "value": "Times-New-Roman",
    "label": "Times-New-Roman"
  }, {
    "value": "sans-serif",
    "label": "sans-serif"
  }
];

const language = Vue.$cookies.get("language");
let fontFamily = fontFamily_EN;

if (language === 'zh') {
  fontFamily = fontFamily_ZH;
} else {
  fontFamily = fontFamily_EN;
}

export default fontFamily;